import { Draggable } from "react-beautiful-dnd";
import { getSceneItemStyle } from "./scene";
import Chain from "../../icons/chain";
import Delete from "../../icons/delete";

const ScenesWithoutDayScene = (props) => {
    const { scene, index, readOnly, toggleSelectionInGroup, multiSelectTo, toggleSelection, isSelected, isGhosting, colorCode, onDeleteSceneInstance, canDeleteScene, sceneInstanceCount } = props;
    const grid = 8;
    // const getDayStyle = (isDragging, draggableStyle, isSelected, isGhosting) => {
    //     return {
    //         // some basic styles to make the items look a bit nicer
    //         userSelect: "none",
    //         //padding: grid * 2,
    //         margin: `0 0 ${grid}px 0`,
    //         borderRadius: "5px",
    //         // change background colour if dragging
    //         background: isGhosting
    //             ? "black"
    //             : isSelected
    //                 ? "#222E44"
    //                 : isDragging
    //                     ? "#222E44"
    //                     : "#040f21",
    //         //color: "white",
    //         // styles we need to apply on draggables
    //         ...draggableStyle
    //     }
    // };




    const primaryButton = 0;

    // Using onClick as it will be correctly
    // preventing if there was a drag
    const onClick = (event: any) => {
        if (readOnly) {
            return;
        }

        if (event.defaultPrevented) {
            return;
        }

        if (event.button !== primaryButton) {
            return;
        }

        // marking the event as used
        event.preventDefault();

        performAction(event);
    };

    // Determines if the platform specific toggle selection in group key was used
    const wasToggleInSelectionGroupKeyUsed = (
        event: MouseEvent | KeyboardEvent
    ) => {
        const isUsingWindows = navigator.platform.indexOf("Win") >= 0;
        return isUsingWindows ? event.ctrlKey : event.metaKey;
    };

    // Determines if the multiSelect key was used
    const wasMultiSelectKeyUsed = (event: MouseEvent | KeyboardEvent) =>
        event.shiftKey;

    const performAction = (event: MouseEvent | KeyboardEvent) => {
        if (wasToggleInSelectionGroupKeyUsed(event)) {
            toggleSelectionInGroup(scene.sceneId);
            return;
        }

        if (wasMultiSelectKeyUsed(event)) {
            multiSelectTo(scene.sceneId);
            return;
        }

        toggleSelection(scene.sceneId);
    };

    return (

        <Draggable
            key={scene.sceneId}
            draggableId={scene.sceneId}
            index={index}>
            {(draggableProvided, draggableSapshot) => {
                const rowStyle = getSceneItemStyle(
                    draggableSapshot.isDragging,
                    draggableProvided.draggableProps.style,
                    isSelected,
                    isGhosting,
                    scene.dayNight,
                    scene.interiorExterior,
                    colorCode
                );

                return (
                    <tr
                        onClick={(e) => onClick(e)}
                        ref={draggableProvided.innerRef}
                        {...draggableProvided.draggableProps}
                        {...draggableProvided.dragHandleProps}
                        style={rowStyle}>
                        <td>  {!readOnly && <i className="material-icons">
                            drag_indicator
                        </i>} {scene.number} - {scene.settingName}
                            {sceneInstanceCount > 1 && (
                                <span className="chain-icon" title={`Appears on ${sceneInstanceCount} days`}>
                                    <Chain style={{ width: '14px', height: '14px', marginLeft: '0.5rem', verticalAlign: 'middle', color: rowStyle.color }} />
                                </span>
                            )}
                        </td>
                        <td className="scene-actions">
                            {!readOnly && canDeleteScene && (
                                <button
                                    className="button is-small is-text delete-scene-button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDeleteSceneInstance(scene._instanceId);
                                    }}
                                    title="Delete this scene instance">
                                    <span className="icon">
                                        <Delete style={{ width: '16px', height: '16px', marginRight: 0, color: rowStyle.color }} />
                                    </span>
                                </button>
                            )}
                        </td>
                    </tr>
                );
            }}
        </Draggable>
    )
}

export default ScenesWithoutDayScene;